import React, { useState } from 'react';

function FinanceCard({
  title,
  type,
  templateId,
  data,
  loading,
  error,
  onFetch
}) {
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(true);
    onFetch(type, templateId);
  };

  const maskAccount = (acc) =>
    acc ? `XXXXXX${acc.slice(-4)}` : '—';

  return (
    <div style={styles.card}>
      {/* HEADER */}
      <div style={styles.header}>
        <h3 style={styles.title}>{title}</h3>
        {data && <span style={styles.badge}>Fetched</span>}
      </div>

      {/* BODY */}
      <div style={styles.cardContent}>
        {/* TOTAL */}
        {data && (
          <div style={styles.totalWrapper}>
            <p style={styles.totalLabel}>Total Value</p>
            <h2 style={styles.totalAmount}>
              ₹{data.reduce((sum, i) => sum + i.fi_data.Account.Summary.currentValue, 0)
                .toLocaleString('en-IN')}
            </h2>
          </div>
        )}

        {/* LOADING STATE */}
        {loading && (
          <div style={styles.loader}>
            Fetching secure financial data…
          </div>
        )}

        {/* DETAILS */}
        {expanded && data && (
  <div style={styles.details}>
    {data.map((item, index) => {
      const holding =
        item?.fi_data?.Account?.Summary?.Investment?.Holdings?.Holding;

      const isinDescription = Array.isArray(holding)
        ? holding?.[0]?.isinDescription
        : holding?.isinDescription;
      const isin = Array.isArray(holding)
        ? holding?.[0]?.isin
        : holding?.isin;

      return (
        <div key={index} style={styles.detailRow}>
          <div>
            <p style={styles.accountType}>
              {isinDescription}
            </p>
            <p style={styles.accountNumber}>
              {isin}
            </p>
          </div>
          <span style={styles.value}>
            ₹
            {item?.fi_data?.Account?.Summary?.currentValue?.toLocaleString(
              'en-IN'
            )}
          </span>
        </div>
      );
    })}
  </div>
)}


        {/* ERROR */}
        {error && <p style={styles.error}>{error}</p>}
      </div>

      {/* CTA */}
      <div style={styles.cardActions}>
        <button
          onClick={handleClick}
          disabled={loading}
          style={{
            ...styles.fetchButton,
            opacity: loading ? 0.6 : 1
          }}
        >
          {data ? 'Refresh Data' : loading ? 'Fetching…' : 'Fetch Details'}
        </button>
      </div>
    </div>
  );
}
const styles = {
  card: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    transition: 'transform 0.2s ease',
  },

  header: {
    padding: '16px 20px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  title: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
  },

  badge: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: '12px',
  },

  cardContent: {
    padding: '20px',
  },

  totalWrapper: {
    marginBottom: '16px',
  },

  totalLabel: {
    margin: 0,
    fontSize: '12px',
    color: '#777',
  },

  totalAmount: {
    margin: '4px 0 0',
    fontSize: '28px',
    color: '#1976d2',
  },

  loader: {
    fontSize: '14px',
    color: '#666',
    padding: '10px 0',
  },

  details: {
    marginTop: '16px',
    borderTop: '1px solid #eee',
  },

  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderBottom: '1px solid #f3f3f3',
  },

  accountType: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 500,
  },

  accountNumber: {
    margin: 0,
    fontSize: '12px',
    color: '#888',
  },

  value: {
    fontWeight: 600,
  },

  error: {
    color: '#d32f2f',
    fontSize: '14px',
    marginTop: '10px',
  },

  cardActions: {
    padding: '16px 20px',
    backgroundColor: '#fafafa',
  },

  fetchButton: {
    width: '100%',
    padding: '12px',
    borderRadius: '8px',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  },
};

export default FinanceCard;
